import { TFunction } from 'i18next';
import { TableTabs } from '../enums';

type Args = {
  t: TFunction<'translation', undefined>;
  allCounter: number;
  selectedCounter: number;
};

export default function getTableTabs({ t, allCounter, selectedCounter }: Args) {
  return [
    {
      label: t('all'),
      value: TableTabs.All,
      counter: allCounter,
    },
    {
      label: t('selected'),
      value: TableTabs.Selected,
      counter: selectedCounter,
    },
  ];
}
